module.exports = __webpack_public_path__ + "img/pragmaticplay.87adfe6b.jpg";